import { useEffect, useContext } from 'react';
import { ToolsContext } from '../contexts';

export const useScrollPosition = (
    scrollableRef,
    scrollPositionChange,
    dependencies,
) => {
    const tools = useContext(ToolsContext);

    // arrows functionality
    useEffect(() => {
        if (scrollableRef && scrollableRef.current) {
            const updateScrollPosition = tools.debounce(() => {
                if (scrollableRef?.current) {
                    const offsetWidth = scrollableRef.current.offsetWidth;
                    const scrollLeft = scrollableRef.current.scrollLeft;
                    const scrollWidth = scrollableRef.current.scrollWidth;

                    // hide arrow on initial scroll position
                    if (scrollLeft === 0) {
                        scrollPositionChange('start');
                    }

                    // show left arrow if scrolled to right
                    if (scrollLeft > 0) {
                        scrollPositionChange('middle');
                    }

                    // show right arrow if scroll present
                    if (scrollWidth > offsetWidth) {
                        scrollPositionChange('scrollable');
                    }

                    // if scrolled till the end - hide right arrow
                    // uses 1 over 0 to bypass an issue when less than a pixel left after scrolling
                    if (scrollWidth - (offsetWidth + scrollLeft) <= 1) {
                        scrollPositionChange('end');
                    }
                }
            }, 50);

            // initial run
            updateScrollPosition();

            // calculate on scroll
            scrollableRef.current.addEventListener('scroll', updateScrollPosition);
            window.addEventListener('resize', updateScrollPosition);

            return () => {
                scrollableRef?.current?.removeEventListener('scroll', updateScrollPosition);
                window.removeEventListener('resize', updateScrollPosition);
            };
        }
    }, dependencies);
};
